import { useEffect } from 'react'
import { useAuthClient } from '~/features/app-hooks'

type Props = {
  provider: string
  code: string
}
export function OAuthLoginPage({ provider, code }: Props) {
  const authClient = useAuthClient()

  useEffect(() => {
    authClient.loginWithOAuthCode(provider, code).then((res) => {
      if (res.status === 'succeeded') {
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl
        } else {
          console.error('No redirect URL found')
        }
      }
    })
  }, [provider, code])

  return <div />
}
